module.exports = __webpack_public_path__ + "img/3.6f7d5bfe.jpg";